import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Iframe from "@/components/editor/primitives/iframe/iframe-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

const TextWrapper = withViewportStyle("div")`
  text-align: center;
  margin-bottom: ${rem(40)};

  .text-primitive.headingTwo {
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }
`;

export default function TopLevelIFrame() {
  const {
    connectors: { connect },
    id,
  } = useNode();

  return (
    <Wrapper ref={connect} id={id}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <TextWrapper>
            <Element
              id="title"
              is={Text}
              text="IFrame block"
              element="h2"
              pattern="headingTwo"
            />
          </TextWrapper>
          <Element
            id="iframe"
            is={Iframe}
            src="https://open.spotify.com/embed?uri=spotify:album:5ht7ItJgpBH7W6vJ5BqpPr"
            title="Spotify playlist"
            height="300px"
            width="300px"
          />
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(BlockBackgroundColorWrapper)`
  iframe {
    width: 100%;
  }
`;

TopLevelIFrame.craft = {
  custom: {
    displayName: "Iframe",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
